import { Controller } from "@hotwired/stimulus"

// Scrolls a horizontal-scroll track left/right by roughly one card width.
// Markup:
//   <div data-controller="horizontal-scroll">
//     <button data-action="horizontal-scroll#prev">...</button>
//     <button data-action="horizontal-scroll#next">...</button>
//     <div data-horizontal-scroll-target="track">...cards...</div>
//   </div>
export default class extends Controller {
  static targets = ["track"]

  prev() {
    this.trackTarget.scrollBy({ left: -this.#step(), behavior: "smooth" })
  }

  next() {
    this.trackTarget.scrollBy({ left: this.#step(), behavior: "smooth" })
  }

  #step() {
    const firstCard = this.trackTarget.firstElementChild
    if (!firstCard) return this.trackTarget.clientWidth
    const style = window.getComputedStyle(this.trackTarget)
    const gap = parseFloat(style.columnGap || style.gap || 0) || 0
    return firstCard.getBoundingClientRect().width + gap
  }
}
